import NextLink from 'next/link';

import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import Image from 'components/Image';
import Layout from 'components/Layout';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';
import LINKS from 'constants/links';

const onBackToHomeButtonClick = () => {
  sendEvent({ action: 'back_to_home', category: 'page_error_404' });
};

const Custom404 = () => (
  <Layout withGridLayout={false}>
    <div className="mb-20 flex flex-col items-center">
      <Image
        alt="Página não encontrada"
        className="mt-8 md:mt-20 md:h-[332px] md:w-[573px]"
        height={198}
        loading={null}
        src={`${APP.LOCAL_IMAGE_PATH}/error/404.svg`}
        width={343}
        priority
      />
      <Heading as="h1" className="mt-8 px-4 text-center" size="size2">
        {placeholder('titles.404')}
      </Heading>
      <Text className="mt-4 max-w-[226px] text-center md:max-w-fit">
        {placeholder('subtitles.404')}
      </Text>
      <NextLink href={LINKS.HOME} passHref>
        <Button as="a" className="mt-6" onClick={onBackToHomeButtonClick}>
          {placeholder('actions.goBackHome')}
        </Button>
      </NextLink>
    </div>
  </Layout>
);

export default Custom404;
